import React, {useState} from 'react';
import { Modal, Popover, Tooltip } from 'antd';
import {
  NoIcon,
  SmartphoneIcon,
  ContactCenterIcon,
  GisIcon,
  EmailIcon,
  DocumentFlowIcon,
  CityPortalIcon,
  CityPortalOrangeIcon,
  MaksIcon,
  WebIcon,
  EmployeeIcon,
} from '../../../resource/icons';
import IconCheckbox from '../../icon-checkbox';

export const CreationMethodIcon = ({
  methodId,
  style,
  className,
  companyId,
  ...props
}) => {
  switch (methodId) {
    case 1:
      return <NoIcon {...props} style={style || {}} className={className} />
    case 2:
      return <SmartphoneIcon {...props} style={style || {}} className={className} />
    case 3:
      return <ContactCenterIcon {...props} style={style || {}} className={className} />
    case 4:
      return <GisIcon {...props} style={style || {}} className={className} />
    case 5:
      return <EmailIcon {...props} style={style || {}} className={className} />
    case 6:
      return <DocumentFlowIcon {...props} style={style || {}} className={className} />
    case 7:
      return [673].includes(companyId) ? (
        <CityPortalOrangeIcon
          {...props}
          style={style || {}}
          className={className}
        />
      ) : (
        <CityPortalIcon
          {...props}
          style={style || {}}
          className={className}
        />
      );
    case 8:
      return <WebIcon {...props} style={style || {}} className={className} />
    case 9:
      return <EmployeeIcon {...props} style={style || {}} className={className} />
    case 10:
      return <MaksIcon {...props} style={style || {}} className={className} />
    default: 
      return null
  }
}

const CreationMethodsPanel = ({record, methods, onChange, iconStyle, iconClassName, ...props}) => {
  return (
    <div {...props}>
      {methods
        .filter(cm => cm.canSetManually === true)
        .map(cm => <div key={cm.id} style={{marginTop: 10}}>
          <IconCheckbox
            icon={<CreationMethodIcon methodId={cm.id} style={iconStyle} className={iconClassName} />}
            value={record.creationMethod.id === cm.id}
            onChange={typeof onChange === 'function' && record.creationMethod.id !== cm.id ? () => onChange(record.id, cm) : undefined}
            style={{display: 'flex'}}
          >
            {cm.name}
          </IconCheckbox>
        </div>)}
    </div>
  );
}

const ChangeCreationMethod = ({record, methods, onOk, iconStyle, spanStyle, iconClassName, children}) => {

  const [visible, setVisible] = useState(false);

  const handleChange = (requestId, method) => {

      setVisible(false);

      Modal.confirm({
        title: 'Изменить метод создания заявки?',
        content:
          <div>
            Заявка: <strong>{requestId}</strong><br />
            Установить метод создания заявки <strong>{method.name}</strong>
          </div>,
        onOk: () => {
          const {canSetManually, ...restFields} = method; 
          onOk({requestId: record.id, method: restFields})
        },
        onCancel: () => {},
      })

	}

  return <Popover							
      placement="right"
      content={
        <CreationMethodsPanel
          record={record}
          methods={methods}
          onChange={handleChange}
          iconStyle={iconStyle}
          iconClassName={iconClassName}
        />
      }
      title={
        <div>
          <NoIcon style={iconStyle} />
          <span style={spanStyle}>Способ создания</span>
        </div>
      } 
      trigger='click'
      visible={visible}
      onVisibleChange={v => setVisible(v)}
    >
      {children}
    </Popover>
}

const RequestCreationMethod = ({
  record,
  methods,
  onOk,
  iconStyle,
  spanStyle,
  iconClassName,
  isStatistics = false,
}) => {
  const icon = (
    <Tooltip
      mouseLeaveDelay={0}
      title={record.creationMethod.name}
    >
      <CreationMethodIcon
        methodId={record.creationMethod.id}
        companyId={record.companyId}
        style={iconStyle}
        className={iconClassName}
      />
    </Tooltip>
  );

  const canChange =
    methods?.find((method) => method.id === record.creationMethod.id)
      ?.canSetManually &&
    typeof onOk === 'function' &&
    !isStatistics;

  return canChange
    ?  
    <ChangeCreationMethod record={record} methods={methods} onOk={onOk} iconStyle={iconStyle} spanStyle={spanStyle} iconClassName={iconClassName}>{icon}</ChangeCreationMethod>
    :
    icon
}

export default RequestCreationMethod;
